export const VERSION_INFO = { tag: '2.85.1', branch: '2.85.1', commit: 'e16d2c5b6d8ff45736dd45a7da8ba6e2cde15f91', date: 'Thu Feb 12 08:43:41 UTC 2026' }
